<template>
  <div>

    <v-dialog v-model="displayForm" max-width="600px" persistent>
      <v-card class="px-5 py-10" rounded="lg">
        <v-card-text>
          <slot>
            <h2 class="text-center mb-5 pb-5">Text Replacement Form</h2>
          </slot>
          <slot>
            <v-form ref="textReplacementFrom" v-model="formValid">
              <v-text-field
                v-model="key"
                placeholder=" "
                :rules="rules.required"
                v-on:focus="
                  () => {
                    this.$vtt.startSpeechListener((text) => {
                      this.key = `${this.key || ''} ${text}`;
                    }, 'tr_key');
                  }
                "
                v-on:click="
                  () => {
                    this.$vtt.setModel('tr_key');
                  }
                "
              >
                <template v-slot:label>
                  <h3>Key <span class="red--text">*</span></h3>
                </template>
              </v-text-field>

              <v-textarea
                v-model="replacement"
                placeholder=" "
                rows="3"
                :rules="rules.required"
                v-on:focus="
                  () => {
                    this.$vtt.startSpeechListener((text) => {
                      this.replacement = `${this.replacement || ''} ${text}`;
                    }, 'tr_replacement');
                  }
                "
                v-on:click="
                  () => {
                    this.$vtt.setModel('tr_replacement');
                  }
                "
              >
                <template v-slot:label>
                  <h3>Replacement <span class="red--text">*</span></h3>
                </template>
              </v-textarea>
            </v-form>
          </slot>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Confirm Btn -->
          <v-btn
            rounded
            depressed
            color="primary"
            width="100px"
            class="mx-3"
            @click="save()"
          >
            {{ buttonLabel }}
          </v-btn>

          <v-btn
            rounded
            depressed
            color="secodary"
            width="100px"
            class="mx-3"
            @click="closeModal()"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="saveMessageDialog" max-width="400px" persistent>
      <v-card class="px-5 py-10" rounded="lg">
        <v-card-text>
          <slot>
            <h2 class="text-center">
              {{ saveMessage }}
            </h2>
          </slot>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Confirm Btn -->
          <v-btn rounded depressed color="primary" width="100px" class="mx-3" @click="saveMessageDialog = false;">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "TextReplacementFormDialog",
  props: ["showDialog", "type", "tr_key", "tr_replacement"],
  data() {
    return {
      formValid: false,
      rules: {
        required: [(value) => !!value || "This field is required."],
      },
      id: 0,
      key: "",
      replacement: "",
      saveMessage: "",
      saveMessageDialog: false
    };
  },
  computed: {
    displayForm() {
      return this.showDialog;
    },
    buttonLabel() {
      return this.type == "update" ? "Update" : "Save";
    }
  },
  methods: {
    closeModal() {
      this.$parent.showDialog = false;
    },
    async save() {
      this.$refs.textReplacementFrom.validate();
      let res = null;
      if (this.formValid) {
        if (this.type == "update") {
          res = await this.$store.dispatch("textreplacement/updateTextReplacement", {
            id: this.id,
            key: this.key,
            replacement: this.replacement,
          });
        } else {
          res = await this.$store.dispatch("textreplacement/createTextReplacement", {
            key: this.key,
            replacement: this.replacement,
          });
        }
        
        this.$store.dispatch('textreplacement/fetchFullTextReplacements');

        if (res.status == 200) {
          this.$parent.searchText();
          this.closeModal();
          this.saveMessage = "Text replacement saved";
          this.saveMessageDialog = true;
        } else {
          this.saveMessage = res.key[0];
          this.saveMessageDialog = true; 
        }
      }
    },
    create () {
      this.key = '';
      this.replacement = '';
      this.id = 0;
    },
    update (id, key, replacement) {
      this.id = id,
      this.key = key,
      this.replacement = replacement;
    }
  },
};
</script>